import { TextField } from '@refinedev/antd';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import LinkTextField from '@/components/general/LinkTextField';
import { ShowInfoGrid, ShowInfoItem } from '@/components/general/ShowInfo/ShowInfo';
import { ShowSection } from '@/components/general/ShowInfo/ShowSection';
import { MACHINES_URLS } from '@/constants/urls';
import { ServiceOrderTypeString } from '@/model/ServiceOrder/ServiceOrder';
import { Ticket } from '@/model/Ticket/Ticket';

interface ServiceOrderShowWorkDetailProps {
  serviceOrder: any;
}

const ServiceOrderShowWorkDetail = (props: ServiceOrderShowWorkDetailProps) => {
  const { t } = useTranslation();
  const { serviceOrder } = props;

  return (
    <ShowSection title={t('Detalles del trabajo realizado')}>
      <ShowInfoGrid>
        <ShowInfoItem label={serviceOrder.tickets > 1 ? t('Tickets') : t('Ticket')}>
          <ul>
            {serviceOrder.tickets && serviceOrder.tickets.length > 0 ? (
              serviceOrder.tickets.map((ticket: Ticket | number) =>
                typeof ticket === 'number' ? (
                  <li key={ticket}>
                    <LinkTextField local to={`/tickets/show/${ticket}`} label={`${ticket}`} />
                  </li>
                ) : (
                  <li key={ticket.id}>
                    <LinkTextField
                      local
                      to={`/tickets/show/${ticket.id}`}
                      label={`${ticket.ticket_title_str} (${ticket.id.toString()})`}
                    />
                  </li>
                ),
              )
            ) : (
              <TextField value="-" />
            )}
          </ul>
        </ShowInfoItem>
        <ShowInfoItem label={t('Tipo')}>
          <Tag>{ServiceOrderTypeString[serviceOrder.type] ?? '-'}</Tag>
        </ShowInfoItem>

        <ShowInfoItem
          label={serviceOrder.moviles > 1 ? t('Maquinas involucradas') : t('Maquina involucrada')}>
          <ul>
            {serviceOrder.moviles && serviceOrder.moviles.length > 0 ? (
              serviceOrder.moviles.map((movil: any) => (
                <li key={movil.id}>
                  <LinkTextField
                    admin
                    to={`${MACHINES_URLS.ADMIN_MOVIL}/${movil.id}`}
                    label={`${movil.description} (${movil.id})`}
                  />
                </li>
              ))
            ) : (
              <TextField value="-" />
            )}
          </ul>
        </ShowInfoItem>
        {serviceOrder.delivery_note_links && serviceOrder.delivery_note_links.length > 0 && (
          <ShowInfoItem
            label={
              serviceOrder.delivery_note_links.length > 1
                ? t('Números de remito')
                : t('Número de remito')
            }>
            <ul>
              {serviceOrder.delivery_note_links.map((link: string, index: number) => (
                <li key={link}>
                  <LinkTextField
                    external
                    to={link}
                    label={link.split('source_code=')[1] ?? `${t('Número de remito')} ${index + 1}`}
                  />
                </li>
              ))}
            </ul>
          </ShowInfoItem>
        )}

        <ShowInfoItem label={t('Descripción')} colSpan={2}>
          <TextField value={serviceOrder.description ?? '-'} />
        </ShowInfoItem>
      </ShowInfoGrid>
    </ShowSection>
  );
};

export default ServiceOrderShowWorkDetail;
